/**
 * A simple abstraction around localStorage.getItem. Exported so that we can mock it.
 * @alias getLocalStorageLoggingLevelOverride
 * @internal
 */
export default (function () {
  if (typeof window !== 'undefined' && window.localStorage) {
    return window.localStorage.getItem('nw.logging.level.global');
  }

  return '';
});